var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('vue-qrious',{staticClass:"qr",staticStyle:{"margin-top":"inherit"},attrs:{"size":170,"value":"test qr"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }